import { PlusOutlined } from '@ant-design/icons';
import { Grid, Space } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import { AddAgentUserModal } from 'features/users/components/modals/add-agent-user-modal';
import { UserFilterFormValues } from 'features/users/components/users-filter-form/types';
import { UsersFilterForm } from 'features/users/components/users-filter-form/users-filter-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { CompanyType } from 'types';

const { useBreakpoint } = Grid;

type UsersTopBarProps = {
  getInitialFilterValues: UserFilterFormValues;
  handleFilter: (values: UserFilterFormValues) => void;
  agentUserEditData: any;
};

export const AgentUsersTopBar = ({
  getInitialFilterValues,
  handleFilter,
  agentUserEditData,
}: UsersTopBarProps) => {
  useState<CompanyType>();
  const { t } = useTranslation();
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const screens = useBreakpoint();
  const formId = 'users-filters-form';
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setShowAddUserModal(false);
    document.body.style.overflow = 'visible';
  }
  const handleNavigateRole=()=>{
    navigate(ROUTES.USERS_AGENT_MANAGE_ROLE); // Navigate with encoded name

  }
  const handleOpenModal = () => {
    setShowAddUserModal(true);
    document.body.style.overflow = 'hidden';
  }

  return (
    <>
      <div className={`cstmrightmdl ${showAddUserModal && "show"}`}>
        <AddAgentUserModal onClose={handleCloseModal} agentUserEditData={agentUserEditData} />
      </div>

      <ContentTopBar
        title={t('adminUsers.heading.suffix-agent')}
        renderButtons={
          <Space>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={handleOpenModal}
            >
              {t('adminUsers.addNewAgent')}
            </Button>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={handleNavigateRole}
            >
              {t('adminUsers.addNewManageRole')}
            </Button>
          </Space>
        }
      />
      <ContentFilters formId={formId}>
        <UsersFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
